import { useMemo } from "react";
import GOINode from "../GOINode";
import NodeHeader from "./NodeHeader";

// Function to calculate margin-left style based on level and margin
const calculateMarginLeft = (level, margin) => {
  if (level === 1) {
    return `${margin}px`;
  } else if (level > 1) {
    return `${margin + 26}px`;
  } else {
    return "0px";
  }
};

// Component to render the node header with GOINode.
// Its the component where we show the status and open as active object button
const NodeHeaderWithGOINode = ({
  showField,
  item,
  toggleShowFields,
  margin,
  level,
  saving,
  editMode,
}) => {
  // function to toggle the visibility of fields
  const setShowFieldsValue = () => {
    toggleShowFields(item.id);
  };

  // calculate margin-left style using useMemo for performance optimization
  const marginLeft = useMemo(
    () => calculateMarginLeft(level, margin),
    [level, margin]
  );

  return (
    <>
      <NodeHeader
        style={{ marginLeft }}
        toggleShowHide={setShowFieldsValue}
        item={item}
        editMode={editMode}
        showHeader={showField}
      />
      {showField && (
        <GOINode
          key={`${item.id}-index`}
          inputData={item}
          hideTitles={true}
          editMode={editMode}
          savingParentValue={saving}
        />
      )}
    </>
  );
};

export default NodeHeaderWithGOINode;
